import { ReactComponent as IconTick } from "assets/images/icons/project-icons/tick-mark.svg"

const CustomCheckbox = ({widthHeight, checked, onClick}) => {
    const size = widthHeight || 5
    
    return (
        <div onClick={onClick} className={`w-${size} h-${size} rounded-[5px] flex items-center justify-center border cursor-pointer ${checked ? "bg-[#edfaf6] border-ep-primary-600" : "border-gray-400 bg-white"}`}>
            <div className={`transition-all duration-300 ${checked ? "opacity-100" : "opacity-0"}`}>
                <IconTick />
            </div>
        </div>
    )
}

export default CustomCheckbox